// extracted by mini-css-extract-plugin
export default {"error":"ErroredColumnHead_error__DggIX"};